import { useQuery } from '@tanstack/react-query'

import { api } from '@/utils/api'
import type { Team } from '@/types'

const fetchOrgTeams = async (organizationId: string) => {
  const res = await api.get(`/organizations/${organizationId}/teams`)
  return res.data.data ?? []
}

export const useOrgTeams = (organizationId?: string) => {
  return useQuery<Team[]>({
    enabled: !!organizationId,
    queryKey: ['org-teams', organizationId],
    queryFn: () => fetchOrgTeams(organizationId!),
  })
}
